import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'constants';

class TeamWasSetForEachStackItemValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        const firstGroupItems = stacking.getFirstGroupItems();

        this.validateTeamInItems(firstGroupItems);

        if (this.hasErrors() || !stacking.isDoubleStackModeEnabled()) {
            return;
        }

        const secondGroupItems = stacking.getSecondGroupItems();

        this.validateTeamInItems(secondGroupItems);
    }

    private validateTeamInItems(items): void {
        for (let item of items) {
            if (!item.team) {
                this.addError('A team in the controlled by name stack has to be specified, please check.');
                break;
            }
        }
    }
}

export default TeamWasSetForEachStackItemValidator;
